<template>
    <p class="product-name font-medium truncate">
        <feather-icon
          icon="CheckCircleIcon"
          v-if="active"
          svgClasses="w-5 h-5 hover:text-primary stroke-current"
        />
        <feather-icon
          icon="CircleIcon"
          v-else
          svgClasses="w-5 h-5 hover:text-primary stroke-current"
        />
    </p>
</template>

<script>
    export default {
        name: 'active-item',
        props: {
            active: {
                type: Boolean,
                required: true
            }
        }
    }
</script>
